export const GRAPH = {
  width: window.innerWidth - 660,
  height: 280,
};
